"use client";

import { usePathname } from "next/navigation";
import { Separator } from "@/components/ui/separator";
import { useAiSidePanel } from "../ai-side-panel-provider";
import { memoTargetFromPathname } from "../memo-node-id";
import { AiSidePanelToggle } from "./ai-side-panel-toggle";
import { MemoHeaderToggle } from "./memo-header-toggle";

/**
 * ヘッダー右側のAI・メモ導線をまとめて描画する。
 *
 * 区切り線はAI専用ではなく、この操作群全体をユーティリティ群から分けるためのものなので、
 * いずれかの導線が表示される場合だけ描画する。
 */
export function WorkspaceHeaderPrimaryActions({
  ariaLabel,
}: {
  ariaLabel: string;
}) {
  const { isEnabled: isAiEnabled } = useAiSidePanel();
  const pathname = usePathname();
  const hasMemoEntry = memoTargetFromPathname(pathname) !== null;

  if (!isAiEnabled && !hasMemoEntry) {
    return null;
  }

  return (
    <>
      <Separator
        orientation="vertical"
        className="mx-1.5 hidden self-center bg-muted-foreground/40 data-[orientation=vertical]:!h-[18px] data-[orientation=vertical]:!w-px @xl:block dark:bg-muted-foreground/45"
      />
      <div
        role="group"
        aria-label={ariaLabel}
        className="flex items-center gap-2"
      >
        <AiSidePanelToggle />
        <MemoHeaderToggle />
      </div>
    </>
  );
}
